
<app-menu *ngIf="showAdmin" [adminMenu]="true" (menuChanged)="onMenuChanged($event)" (closeSidebar)="closeSidebarMenu()"></app-menu>

<app-menu *ngIf="!showAdmin" [adminMenu]="false" (menuChanged)="onMenuChanged($event)" (closeSidebar)="closeSidebarMenu()"></app-menu>
